import clsx from "clsx";
import style from "components/LinkButton.module.scss";
import Target from "components/Target";
import React from "react";
import { ArrowRight } from "react-feather";

const LinkButton = ({ target, label }) => {
  return (
    <div className={clsx("text-center")}>
      <Target
        className={clsx(
          "LinkButton",
          "max-w-96 inline-flex h-14 items-center rounded-full bg-sky-500 pl-5 pr-10 text-white"
        )}
        target={target}
      >
        <div className={style.icon}>
          <ArrowRight strokeWidth={1.5} size={18} />
        </div>
        <div className={style.label}>{label}</div>
      </Target>
    </div>
  );
};

export default LinkButton;
